<ng-template [ngIf]="!inputDropdown && !notclickOutside">
  <input type="text" class="input-date inputTypeDate {{class}}" #inputDate id="{{id}}" [ngModel]="model" clickOutside (clickOutside)="clickOutsideDate($event)"
    (ngModelChange)="changeDate($event);" [placeholder]="placeholder" [ngClass]="{'error': isHasError}" (focus)="focus(date);"
    ngbDatepicker NgbInputDatepicker #date="ngbDatepicker" [autoClose]="false" (blur)="blur(date)"
    (dateSelect)="selectDate($event)" (keydown)="setFocuscalendar($event)" (click)="getPosition($event)"
    (keydown.enter)="date.close();keyenter($event)" autocomplete="off" [disabled]="disable" maskPass  [visible]="condition"  [dateOuCouleure]="true"
    [container]="container ? 'body' : ''" [maxDate]="max" [minDate]="min"  [readonly]="readonly">
</ng-template>

<ng-template [ngIf]="!inputDropdown && notclickOutside">
  <input type="text" class="input-date inputTypeDate {{class}}" #inputDate id="{{id}}" [ngModel]="model"
    (ngModelChange)="changeDate($event);" [placeholder]="placeholder" [ngClass]="{'error': isHasError}" (focus)="focus(date);"
    ngbDatepicker NgbInputDatepicker #date="ngbDatepicker" [autoClose]="false" (blur)="blur(date)"
    (dateSelect)="selectDate($event)" (keydown)="setFocuscalendar($event)" (click)="getPosition($event)"
    (keydown.enter)="date.close();keyenter($event)" autocomplete="off" [disabled]="disable" maskPass [visible]="condition" [dateOuCouleure]="true"
    [container]="container ? 'body' : ''" [maxDate]="max" [minDate]="min"  [readonly]="readonly">
</ng-template>

<ng-template [ngIf]="inputDropdown">
  <div class="form-group">
    <div class="input-group">
      <input class="input-date inputTypeDate {{class}}" #inputDate placeholder="dd/mm/yyyy"  maskPass  [visible]="condition"  [dateOuCouleure]="true" id="{{id}}" name="dp" [(ngModel)]="model" ngbDatepicker
        #d="ngbDatepicker">
      <div class="input-group-append">
        <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"></button>
      </div>
    </div>
  </div>
</ng-template>